import {
  Box,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";

import AnimalPerformanceIcon from "common/icons/AnimalPerformanceIcon";
import BiodiversityIcon from "common/icons/BiodiversityIcon";
import GrazingManagementIcon from "common/icons/GrazingManagementIcon";
import WaterAndSoilQualityIcon from "common/icons/WaterAndSoilQualityIcon";

// Icon mapping based on action keys
const getIconForKey = (key: string) => {
  const iconMap = {
    Soil_and_Water: <WaterAndSoilQualityIcon />,
    Grazing_and_Farm_Management: <GrazingManagementIcon />,
    Animal_Performance: <AnimalPerformanceIcon />,
    Farmland_Biodiversity: <BiodiversityIcon />,
  };

  return iconMap[key as keyof typeof iconMap] || "📋";
};

// Format key to readable title
const formatTitle = (key: string) => {
  return key
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

type ActionListProps = {
  rawSelectedActions: Record<string, string>;
};

export default function ActionList({ rawSelectedActions }: ActionListProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedValue, setSelectedValue] = React.useState("");
  const handleChange = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setSelectedValue(event.target.value);
  };

  const selectedActions: Record<string, string> = {};

  selectedActions["Soil_and_Water"] = rawSelectedActions["Soil_Analysis"];
  if (rawSelectedActions["Nutrient_Planning_and_Application"]) {
    selectedActions["Soil_and_Water"] = selectedActions[
      "Soil_and_Water"
    ].concat(";", rawSelectedActions["Nutrient_Planning_and_Application"]);
  }
  if (rawSelectedActions["Manure_and_Slurry_Management"]) {
    selectedActions["Soil_and_Water"] = selectedActions[
      "Soil_and_Water"
    ].concat(";", rawSelectedActions["Manure_and_Slurry_Management"]);
  }
  if (rawSelectedActions["Efficiency_and_Input_Reduction"]) {
    selectedActions["Soil_and_Water"] = selectedActions[
      "Soil_and_Water"
    ].concat(";", rawSelectedActions["Efficiency_and_Input_Reduction"]);
  }

  selectedActions["Grazing_and_Farm_Management"] =
    rawSelectedActions["Grazing_and_Grassland_Management"];
  if (rawSelectedActions["Farm_Management"]) {
    selectedActions["Grazing_and_Farm_Management"] = selectedActions[
      "Grazing_and_Farm_Management"
    ].concat(";", rawSelectedActions["Farm_Management"]);
  }

  selectedActions["Animal_Performance"] = rawSelectedActions["Production"];

  selectedActions["Farmland_Biodiversity"] =
    rawSelectedActions["Practical_Biodiversity"];
  if (rawSelectedActions["Biodiversity_Monitoring"]) {
    selectedActions["Farmland_Biodiversity"] = selectedActions[
      "Farmland_Biodiversity"
    ].concat(";", rawSelectedActions["Biodiversity_Monitoring"]);
  }
  // selectedActions["Soil_and_Water"] = (rawSelectedActions["Soil_Analysis"] ?? "").concat(rawSelectedActions["Nutrient_Planning_and_Application"] ?? "", ";", rawSelectedActions["Manure_and_Slurry_Management"] ?? "", ";", rawSelectedActions["Efficiency_and_Input_Reduction"] ?? "")

  return (
    <Box
      sx={{
        maxWidth: 600,
        mx: "auto",
        bgcolor: isMobile ? "#F7FCF1" : "white",
        pt: 2,
      }}
    >
      {Object.entries(selectedActions).map(([key, actions], index) => {
        if (actions) {
          return (
            <Box
              key={key}
              sx={{
                ...(isMobile
                  ? { paddingTop: "20px" }
                  : {
                      mb: 2,
                      borderRadius: "16px",
                      bgcolor: "#FFFFFF",
                      overflow: "hidden",
                      boxShadow:
                        "0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)",
                    }),
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 2,
                  py: 2.5,
                  px: 1,
                  bgcolor: "#FFFFFF",
                  //cursor: "pointer",
                  //"&:hover": {
                  /// bgcolor: "rgba(0, 0, 0, 0.02)",
                  //},
                }}
                // onClick={() => setSelectedValue(key)}
              >
                {/* Icon */}
                <Box
                  sx={{
                    fontSize: "28px",
                    minWidth: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {getIconForKey(key)}
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      fontSize: "16px",
                      mb: 0.5,
                      color: "#000",
                    }}
                  >
                    {formatTitle(key)}
                  </Typography>
                </Box>
              </Box>

              {actions
                .toString()
                .split(";")
                .map((description, index) => {
                  const uniqueElemKey = description;
                  if (
                    !["Submission_Date", "guid", "email"].includes(key) &&
                    description
                  ) {
                    return (
                      <React.Fragment key={uniqueElemKey}>
                        {/* Divider between items */}

                        {index != 0 && <Divider sx={{ mx: 1 }} />}

                        <Box
                          key={key + description}
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 2,
                            py: 2.5,
                            px: 1,
                            bgcolor: "#FFFFFF",
                            // cursor: "pointer",
                            //  "&:hover": {
                            //    bgcolor: "rgba(0, 0, 0, 0.02)",
                            //  },
                          }}
                          // onClick={() => setSelectedValue(key)}
                        >
                          {/* Icon */}
                          {/*<Box
                            sx={{
                              fontSize: "28px",
                              minWidth: "40px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {" "}
                          </Box>*/}

                          {/* Text Content */}
                          <Box sx={{ flex: 1 }}>
                            <Typography
                              variant="body2"
                              sx={{
                                color: "black",

                                fontSize: "14px",
                                lineHeight: 1.5,
                                paddingX: 2,
                              }}
                            >
                              {description}
                            </Typography>
                          </Box>

                          {/* Radio Button */}
                          {/* <Radio
                            checked={selectedValue === key}
                            onChange={handleChange}
                            value={key}
                            name="action-radio"
                            sx={{
                              color: "#d0d0d0",
                              "&.Mui-checked": {
                                color: "#1976d2",
                              },
                            }}
                          />*/}
                        </Box>
                      </React.Fragment>
                    );
                  } else {
                    return <React.Fragment key={uniqueElemKey} />;
                  }
                })}
            </Box>
          );
        } else {
          return <React.Fragment key={key} />;
        }
      })}

      {/* Footer Text */}
      {/* <Typography
        variant="body2"
        sx={{
          textAlign: "center",
          color: "#999",
          mt: 3,
          fontSize: "14px",
        }}
      >
        Click the activity to register as completed
      </Typography>*/}
    </Box>
  );
}

// Example usage:
// <ActionList selectedActions={selectedActions} />
